import React from 'react';
// import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';
import { parseCardInput } from 'app/utils/parsers';

import _ from 'lodash';
import {
  IForfeitsSelector,
  ITeamsSelector,
  IUsersSelector,
  IPurchasesSelector,
  ICartSelector,
} from 'app/types/selector';

import * as paymentEventsSelectors from 'app/ducks/paymentEvents/selectors';

import CheckoutComponent from './CheckoutComponent';

interface ICheckoutForfeitPaymentProps {
  forfeits: IForfeitsSelector;
  purchases: IPurchasesSelector;
  creditCards: any;
  teams: ITeamsSelector;
  users: IUsersSelector;
  cart: ICartSelector;
  match: any;
  errors: any;
  actions: any;
  isLoading: boolean;
  cardIsLoading: boolean;
}

// @(connect(selector, (dispatch) => ({
//   actions: bindActionCreators(actionCreators, dispatch),
// })) as any)
export default class CheckoutForfeitPayment extends React.Component<
ICheckoutForfeitPaymentProps,
{}
> {
  static defaultProps: ICheckoutForfeitPaymentProps = {
    purchases: {},
    forfeits: {},
    teams: {},
    creditCards: {},
    users: {},
    cart: {},
    errors: {},
    match: undefined,
    actions: undefined,
    isLoading: false,
  };

  componentDidMount = () => {
    this.setupPayment();
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (_.isEmpty(prevProps.errors) && !_.isEmpty(this.props.errors)) {
      this.setupPayment(!_.isEmpty(this.props.creditCards.creditCardToken));
    }
  };

  setupForfeitPayment = (withToken = false) => {
    const { currentForfeit } = this.props.forfeits;
    if (
      this.props.users.currentUser !== undefined
    ) {
      this.props.actions.getAllCreditCards();
      if (withToken) {
        this.props.actions.createCreditCardToken({
          secureReference: currentForfeit.secureReference,
          user: { id: this.props.users.currentUser.id },
        });
      }
    }
  };

  setupPayment = (withToken = false) => {
    if (
      this.props.forfeits.currentForfeit
      && !this.props.creditCards.isLoading
    ) {
      this.setupForfeitPayment(withToken);
    }
  };

  submitForfeitPaymentNewCard = async (parsedCardInput): Promise<void> => {
    const { currentForfeit } = this.props.forfeits;

    const cardPayload = {
      cardAccountId: parsedCardInput.cardAccountId,
      user: { id: this.props.users.currentUser.id },
      status: parsedCardInput.saveCardAllowed ? 'active' : 'inactive',
      consumer: { id: null },
    };

    const purchasePayload = {
      purchaseType: 'team-manager-forfeit-payment',
      description: `payment for: ${currentForfeit.friendlyReference}`,
      amount: this.props.cart.totalAmount,
      metadata: {
        payment: {
          'line-items': this.props.cart.lineItems,
        },
      },
      forfeit: {
        id: currentForfeit.id,
      },
      fixtureMatch: {
        id: currentForfeit.fixtureMatch.id,
      },
      organisation: {
        id: currentForfeit.organisation.id,
      },
    };

    const combinedPayload = { cardPayload, purchasePayload };
    await this.props.actions.createCreditCardAndPurchase(combinedPayload);
  };

  submitForfeitPaymentExistingCard = async (): Promise<void> => {
    const { currentForfeit } = this.props.forfeits;

    const purchasePayload = {
      purchaseType: 'team-manager-forfeit-payment',
      description: `payment for: ${currentForfeit.friendlyReference}`,
      amount: this.props.cart.totalAmount,
      metadata: {
        payment: {
          'line-items': this.props.cart.lineItems,
        },
      },
      forfeit: {
        id: currentForfeit.id,
      },
      fixtureMatch: {
        id: currentForfeit.fixtureMatch.id,
      },
      organisation: {
        id: currentForfeit.organisation.id,
      },
      creditCard: {
        id: this.props.creditCards.currentCreditCard.id,
      },
    };

    await this.props.actions.createPurchase(purchasePayload);
  };

  handleSubmit = async (cardData) => {
    const { currentForfeit } = this.props.forfeits;

    // if (this.props.creditCards.creditCardToken) {
    if (currentForfeit.id !== null) {
      if (cardData.newCard) {
        const parsedCardInput = {
          cardAccountId: cardData.cardAccountId,
          saveCardAllowed: cardData.saveCardAllowed,
        };
        typeof DD_LOGS ?? DD_LOGS.logger.info('submit-team-manager-forfeit-payment', {
          env: ENVIRONMENT,
          payload: {
            ...parsedCardInput,
          },
        });
        this.submitForfeitPaymentNewCard(parsedCardInput);
      } else {
        this.submitForfeitPaymentExistingCard();
      }
    }
    // }
  };

  render(): React.ReactNode {
    const { currentForfeit } = this.props.forfeits;
    const fixtureMatch = currentForfeit?.fixtureMatch;

    const shouldRender = !_.isEmpty(currentForfeit)
      && !_.isEmpty(fixtureMatch);

    if (shouldRender) {
      return (
        <CheckoutComponent
          secureReference={currentForfeit.secureReference}
          createCreditCardToken={this.props.actions.createCreditCardToken}
          creditCardUserId={this.props.users.currentUser.id}
          creditCardToken={this.props.creditCards.creditCardToken}
          matchCardData={paymentEventsSelectors.getPaymentEventForMatchCard(
            fixtureMatch,
            currentForfeit.group.id,
          )}
          forfeitId={this.props.match.params.forfeitId}
          existingCard={
            !_.isEmpty(this.props.creditCards.currentCreditCard.id) && this.props.creditCards.currentCreditCard?.status !== 'inactive'
          }
          existingCardMaskedNumber={
            this.props.creditCards.currentCreditCard.creditCardMask
          }
          existingCardExpiry={
            this.props.creditCards.currentCreditCard.creditCardExpiry
          }
          totalAmount={currentForfeit.amount}
          description={currentForfeit.description}
          handleSubmit={this.handleSubmit}
          backendErrors={this.props.errors}
          processingBackendErrors={this.props.processingBackendErrors}
          currentPurchaseStatus={this.props.purchases.currentPurchase?.status}
          isLoading={this.props.isLoading}
          cardIsLoading={this.props.cardIsLoading}
        />
      );
    }
    return null;
  }
}
